// AdminEngineConsolePage.tsx — X11 drop 1 / X10's first step (owner, 2026-10-05): the ENGINE console's own sign-in, a
// separate section of the admin. Its key is the engine's (checked by the engine, never by TubeForge), held only for this
// browser session. Covers is its first piece; the rest of the console waits for the boundary session.
import { useState } from "react";
import { Link } from "react-router-dom";
import { engineOperatorKey, setEngineOperatorKey, clearEngineOperatorKey, looksLikeOperatorKey } from "../../api/engine-console";

export function EngineSignInBanner() {
  const [key, setKey] = useState("");
  if (engineOperatorKey()) return null;
  return (
    <div style={{ border: "1px solid #f59e0b", background: "#fffbeb", borderRadius: 8, padding: 12, marginBottom: 16, fontSize: 13 }}>
      <b>Sign in to the engine console</b> — covers is the engine's operator tool: it reads from the engine with the engine's own
      operator key, not your TubeForge sign-in.
      <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
        <input type="password" aria-label="Engine operator key" value={key} onChange={(e) => setKey(e.target.value)} placeholder="engine operator key"
          style={{ flex: 1, maxWidth: 360, padding: "6px 10px", border: "1px solid #d1d5db", borderRadius: 6 }} />
        <button disabled={!looksLikeOperatorKey(key)} onClick={() => { setEngineOperatorKey(key); window.location.reload(); }}
          style={{ padding: "6px 12px", borderRadius: 6, border: "none", background: looksLikeOperatorKey(key) ? "#111827" : "#9ca3af", color: "#fff" }}>Sign in</button>
      </div>
    </div>
  );
}

export function AdminEngineConsolePage() {
  const [signedIn, setSignedIn] = useState(!!engineOperatorKey());
  return (
    <div style={{ maxWidth: 720 }}>
      <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 4 }}>Engine console</h1>
      <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 16 }}>
        The engine's operator tools, behind the engine's own sign-in (separate from TubeForge's). Its first piece is covers.
      </div>
      {signedIn ? (
        <div style={{ fontSize: 13 }}>
          Signed in to the engine for this browser session. <Link to="/admin/teardowns" style={{ textDecoration: "underline" }}>Open covers →</Link>
          <div style={{ marginTop: 10 }}>
            <button onClick={() => { clearEngineOperatorKey(); setSignedIn(false); }}
              style={{ padding: "6px 12px", borderRadius: 6, border: "1px solid #d1d5db", background: "#fff" }}>Sign out of the engine</button>
          </div>
        </div>
      ) : <EngineSignInBanner />}
    </div>
  );
}
